module.exports = __webpack_public_path__ + "static/img/M-5.b59b698.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mga/M-5.png
// module id = YcGv
// module chunks = 0